import * as constants from 'constants';
import * as conv from './conv';
import * as user from './user';
import * as ui from './ui';
import * as auth from './auth';
import * as fetch from './fetch';
import * as group from './group';
import * as system from './system';
import * as pm from './pm';
import * as uploader from './uploader';
import { db, setAjaxToken, storage, cache } from 'utils';
import { isWeb } from 'core';
import Expo from 'expo';

let dispatch;
let getState;
// login
export const sendProvideAccount = params => dispatch(auth.provideAccount(params));
export const sendVerifyAccount = params => dispatch(auth.verifyAccount(params));

// Application loading.
export const loadInitialData = async au => {
    if (au) {
        await storage.set('auth', au);
    }
    au = await storage.get('auth');
    if (!au) {
        dispatch(ui.showLogin(true));
        return;
    }
    loadStoredData(au);
    dispatch(ui.showLogin(false));
    await db.connect(au.db_key);
    setAjaxToken(au.token);
    dispatch(user.getUser(au));
    dispatch(auth.getSessions(au));
    dispatch(conv.getConvs(au.id));
    dispatch(system.getSystemStatus(au));
};

export const loadStoredData = async au => {
    const cached_user = await storage.get('cached_user');
    cached_user && dispatch(user.setUser(cached_user));
    const sessions = await storage.get('cached_sessions');
    sessions && dispatch(auth.setSessions(au))(sessions);
    const convs = await storage.get('cached_convs');
    convs && dispatch(conv.setStoredConvs(convs));
};

export const showOnline = isActive => dispatch(system.showOnline(isActive));
// Menu
export const selectSettings = () => dispatch(ui.selectAppTab(constants.APP_TABS.SETTINGS));
export const selectGroups = () => dispatch(ui.selectAppTab(constants.APP_TABS.GROUPS));
export const selectPM = () => dispatch(ui.selectAppTab(constants.APP_TABS.PM));

export const clickBack = index => dispatch(ui.goBack(index));
export const clickNext = index => dispatch(ui.goNext(index));

// user
export const clickAddAccount = () => dispatch(ui.openModal(constants.MODALS.ADD_ACCOUNT));
export const clickChangeName = () => dispatch(ui.openModal(constants.MODALS.CHANGE_NAME));
export const sendChangeName = ({ name }) => dispatch(user.changeName({ name }));
export const sendUserUpdate = fields => dispatch(user.update(fields));
export const sendUserAddAccount = params => dispatch(user.addAccount(params));
export const sendUserRemoveAccount = ({ account }) => dispatch(user.removeAccount({ account }));
export const sendUserVerifyAddAccount = params => dispatch(user.verifyAddAccount(params));
export const sendUserAvatar = ({ upload }) => dispatch(user.uploadAvatar({ upload }));

// Groups list
export const selectConv = selected => {
    const state = getState();
    selected = selected || state.conv.list[0];
    if (selected.type === 'PM') {
        dispatch(ui.selectPM(selected.id));
        isWeb && selectPM();
        // if iam in the info page and going to pm from group
        state.ui.selected_group ? clickNext(3) : clickNext(1);
    } else {
        dispatch(ui.selectGroup(selected.id));
        clickNext(1);
    }
    if (!selected.inactive) {
        loadConv(selected);
    }
};
export const jumpToConv = conv => {
    dispatch(ui.jumpToConv(conv));
    loadConv(conv);
};
export const jumpToConvReset = () => dispatch(ui.jumpToConvReset());

const loadConv = selected => {
    const is_group = selected.type === 'GROUP';
    is_group && (isWeb ? selectTasks() : selectChat());
    if (!cache.get(`watched_${selected.id}`)) {
        cache.set(`watched_${selected.id}`, true);
        dispatch(conv.getMessages(selected));
        if (is_group) {
            dispatch(conv.getMembers(selected.id));
            dispatch(group.getTasks(selected.id));
            dispatch(group.getMaterials(selected.id));
            dispatch(group.getSubmissions({ group_id: selected.id, id: getState().user.id }));
        }
    }
};

export const sendSetWatching = item => dispatch(conv.setWatching(item));
export const sendUnsetWatching = item => dispatch(conv.unsetWatching(item));
export const clickJoinGroup = () => dispatch(ui.openModal(constants.MODALS.JOIN_GROUP));
export const sendGroupJoin = secret => dispatch(group.join(secret));
export const clickNewGroup = () => dispatch(ui.openModal(constants.MODALS.NEW_GROUP));
export const sendGroup = ({ title, description }) => dispatch(group.create({ title, description }));

// Groups-Tabs
export const selectChat = () => dispatch(ui.selectGroupTab(constants.GROUP_TABS.CHAT));
export const selectGroupInfo = () => (isWeb ? dispatch(ui.selectGroupTab(constants.GROUP_TABS.INFO)) : clickNext(2));
export const selectPmInfo = () => (!getState().ui.selected_group ? clickNext(2) : clickNext(4));
export const selectMaterial = () => dispatch(ui.selectGroupTab(constants.GROUP_TABS.MATERIAL));
export const selectTasks = () => dispatch(ui.selectGroupTab(constants.GROUP_TABS.TASKS));

// Groups-info
export const sendGroupAvatar = ({ upload, group_id }) => {
    dispatch(group.uploadAvatar({ upload, group_id }));
};
export const sendCloseGroup = ({ group_id }) => dispatch(group.closeGroup({ group_id }));
export const sendOpenGroup = ({ group_id }) => dispatch(group.openGroup({ group_id }));
export const clickBlockedMembers = () => dispatch(ui.openModal(constants.MODALS.BLOCK_LIST));
export const clickEditGroupInfo = () => dispatch(ui.openModal(constants.MODALS.EDIT_GROUP));
export const sendUpdateGroup = ({ group_id, title, description }) => dispatch(group.update({ group_id, title, description }));

// Groups-tasks
export const clickAddTask = () => dispatch(ui.openModal(constants.MODALS.ADD_TASK));
export const sendAddTask = (task, selected) => dispatch(group.addTask(task, selected));
export const sendUpdateTask = (task, task_id, group_id) => dispatch(group.updateTask(task, task_id, group_id));
export const clickEditTask = task_id => {
    dispatch(ui.selectTask(task_id));
    dispatch(ui.openModal(constants.MODALS.EDIT_TASK));
};
export const sendRemoveTask = ({ group_id, task_id }) => dispatch(group.removeTask({ group_id, task_id }));
export const sendSubmission = ({ upload, conv_id, task_id }) => dispatch(group.submit({ upload, conv_id, task_id }));
export const clickViewSubmissions = ({ group_id, task_id }) => {
    dispatch(ui.selectTask(task_id));
    dispatch(group.getSubmissions({ group_id, id: task_id, type: 'admins' }));
    dispatch(ui.openModal(constants.MODALS.SUBMISSIONS));
};
export const sendRemoveSubmissions = ({ conv_id, task_id }) => dispatch(group.deleteSubmission({ conv_id, task_id }));
export const sendStopSubmissionWatch = ({ conv_id, task_id }) => dispatch(group.stopSubmissionWatch({ conv_id, task_id }));

// Group-materials
export const sendMaterial = ({ upload, group_id }) => dispatch(group.addMaterial({ upload, group_id }));
export const removeMaterial = ({ upload_id, group_id }) => dispatch(group.removeMaterial({ upload_id, group_id }));
// export const sendMaterialRemove = ({ upload, group_id }) => dispatch(group.operateMaterialUpload({ upload, group_id }, 'remove'));

// Group-update
export const clickChangeGroupPicture = () => dispatch(ui.openModal(constants.MODALS.GROUP_IMAGE_CHANGE));
export const clickAlterGroup = () => dispatch(ui.openModal(constants.MODALS.ALTER_GROUP));
export const sendGroupUpdate = ({ group_id, fields }) => dispatch(group.update({ group_id, fields }));
export const sendGroupRemove = group_id => dispatch(group.removeGroup(group_id));
export const sendGroupClose = group_id => dispatch(group.close(group_id));
export const sendMakeAdmin = ({ member_id, conv_id }) => dispatch(group.makeAdmin({ member_id, conv_id }));
export const sendUnmakeAdmin = ({ member_id, conv_id }) => dispatch(group.unmakeAdmin({ member_id, conv_id }));

// Group-participants
export const sendRemoveMember = ({ member_id, conv_id, reason, role, report }) => dispatch(group.removeMember({ member_id, conv_id, reason, role, report }));
export const clickRemoveMember = member_id => {
    dispatch(ui.selectMember(member_id));
    dispatch(ui.openModal(constants.MODALS.REMOVE_MEMBER));
};
export const sendUnblockMember = ({ conv_id, member_id }) => dispatch(group.unblockMember({ conv_id, member_id }));
export const sendLeaveGroup = ({ member_id, conv_id, role }) => dispatch(group.leaveGroup({ member_id, conv_id, role }));

// export const clickLeaveGroup = group_id => dispatch(group.leave(group_id));

// PM
export const sendPM = user_id => dispatch(pm.createPM(user_id));

// when you select PM from group_info
export const selectSendPM = ({ id, name, photo }) => {
    const state = getState();
    const user_id = state.user.id;
    const conv_id = [user_id, id].sort().join('');
    const found = state.conv.list.find(conv => conv_id === conv.id);
    if (found) {
        selectConv(found);
    } else {
        dispatch(ui.selectTmpPM(id, name, photo));
        !state.ui.selected_group ? clickNext(1) : clickNext(3);
    }
};

export const removeTmpPM = () => dispatch(ui.removeTmpPM());

// Modals
export const clickCloseModal = () => dispatch(ui.closeModal());

// Settings
export const selectAccount = () => dispatch(ui.selectSettingsItem(constants.SETTINGS_ITEMS.ACCOUNT));
export const selectSupport = () => dispatch(ui.selectSettingsItem(constants.SETTINGS_ITEMS.SUPPORT));
export const selectSuggestions = () => dispatch(ui.selectSettingsItem(constants.SETTINGS_ITEMS.SUGGESTIONS));
export const selectDevices = () => dispatch(ui.selectSettingsItem(constants.SETTINGS_ITEMS.DEVICES));
export const clickLogout = () => dispatch(auth.logout());
export const sendRemoveSession = session_id => dispatch(auth.removeSession(session_id));
// export const clickAddAccount = () =>
//   dispatch(ui.openModal(constants.MODALS.ADD_ACCOUNT));

// Conv
export const sendMessage = item => dispatch(conv.sendMessage(item));
export const sendSetTypingIndicator = ({ conv_id }) => dispatch(conv.setTypingIndicator({ conv_id }));
export const sendUnsetTypingIndicator = ({ conv_id }) => dispatch(conv.unsetTypingIndicator({ conv_id }));
export const clickShareContact = () => dispatch(ui.openModal(constants.MODALS.CONTACTS_LIST));
export const clickShareLocation = () => dispatch(ui.openModal(constants.MODALS.MAP));
export const clickSelectMsg = msg => dispatch(ui.selectMsg(msg));
export const clickContactProfile = () => dispatch(ui.openModal(constants.MODALS.CONTACT_PROFILE));
export const getPrevMessages = conv_id => dispatch(conv.getPrevMessages(conv_id));
export const getNextMessages = conv_id => dispatch(conv.getNextMessages(conv_id));
export const clickGoToMessagesPage = (conv_id, pointer) => dispatch(conv.goToPage(conv_id, pointer));
export const emptyPageMessages = conv_id => dispatch(conv.emptyPageMessages(conv_id));
export const sendDeleteMsg = ({ msg_id, conv_id, is_for_all }) => dispatch(conv.deleteMsg({ msg_id, conv_id, is_for_all }));
export const sendMsgUpload = ({ msg_id, conv_id }) => dispatch(conv.processMsgUpload({ msg_id, conv_id }));

const setDispatcher = (newDispatch, newGetState) => {
    dispatch = newDispatch;
    getState = newGetState;
    fetch.setDispatcher(dispatch, getState);
};

export const closeProviders = () => {
    ui.closeProviders();
};

export const clearAppBadge = () => {
    const state = getState();
    const user_id = state.user.id;
    const session_id = state.user.current_session;
    db.set(`user_session/${user_id}/${session_id}/badge`, null);
    Expo.Notifications.setBadgeNumberAsync(0);
    Expo.Notifications.dismissAllNotificationsAsync();
};

// const uploader = id => uploader_utils.newUpload(id);

// Uploader
export const sendFiles = ({ g_id, u_id, files, onSuccess }) => dispatch(uploader.addFiles({ g_id, u_id, files, onSuccess }));
export const markUploadFinished = ({ g_id, u_id }) => dispatch(uploader.markFinished({ g_id, u_id }));
export const cancelUpload = ({ file_id }) => uploader.cancelUpload({ file_id });

export { user, ui, auth, fetch, group, setDispatcher, uploader };



// WEBPACK FOOTER //
// ./src/actions/index.js